<template>
  <div>
    <v-card class="mt-2 mb-1">
      <v-card-text>
        <TasksReport />

        <v-card-title class="text-h2 mb-1 mt-6">Назначенные задания</v-card-title>

        <div>
          <div class="ml-a tasks-filter">
            <v-btn-toggle v-model="filter.groupBy" color="primary" dense group borderless mandatory>
              <v-btn v-for="(group, idx) in groupListBy" :key="`${group.id}-${idx}`" text :value="group.id">
                {{ group.name }}
              </v-btn>
            </v-btn-toggle>

            <v-spacer></v-spacer>
            <v-select
              label="Группа заданий"
              class="mr-5"
              item-text="title"
              item-value="id"
              v-model="filter.taskGroup"
              :items="taskGroupList"
            />
            <DateRangePicker
              label="Укажите период С - До"
              grow
              v-model="filter.date"
              :disabled="shouldDisableDatepicker"
              :max="$date().format('YYYY-MM-DD')"
            />
          </div>
        </div>

        <v-progress-linear v-if="loadingList" indeterminate></v-progress-linear>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th></th>
                <th style="font-size: 17px; color: #000;">Как часто</th>
                <th style="font-size: 17px; color: #000;">Начало</th>
                <th style="font-size: 17px; color: #000;">Завершение</th>
                <th>
                  <v-btn elevation="0" outlined icon small @click="loadPrevDatePeriod">
                    <v-icon>keyboard_arrow_left</v-icon>
                  </v-btn>
                </th>
                <th
                  v-for="(item, idx) in tableHeader"
                  :key="`tableHeader-${idx}`"
                  class="text-center"
                  style="font-size: 14px; color: #000;"
                >
                  {{ item.title }}
                </th>
                <th>
                  <v-btn elevation="0" outlined icon small :disabled="shouldDisableLoadNextPeriod" @click="loadNextDatePeriod">
                    <v-icon>keyboard_arrow_right</v-icon>
                  </v-btn>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(group, groupIdx) in list">
                <tr :key="groupIdx">
                  <td :colspan="tableColumnsLength">
                    <div class="d-flex align-center" style="width: 100%;justify-content: space-between;">
                      <span class="font-weight-bold" style="font-size: 17px">{{ group.name }}</span>

                      <v-btn x-small color="primary" class="ml-5" @click.stop="taskAdd(group)">
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </div>
                  </td>
                </tr>

                <template v-for="(row, itemIdx) in group.items">
                  <tr
                    :key="`${groupIdx}-${itemIdx}`"
                    :class="{ 'task-close': row.finished }"
                    @click.prevent="taskShow(group, row)"
                  >
                    <td>
                      <div :class="{ 'text-decoration-line-through': row.finished }">{{ row.name }}</div>

                      <div class="d-flex mt-1">
                        <v-chip v-if="row.finished" x-small>Задание на паузе</v-chip>
                        <v-chip v-if="row.diseases" x-small>{{ row.diseases.name }}</v-chip>
                      </div>
                    </td>

                    <td>{{ row.periodicity ? row.periodicity.name : "-" }}</td>
                    <td>{{ $date(row.startAt).format("DD.MM.YYYY") }}</td>
                    <td>{{ row.endAt ? $date(row.endAt).format("DD.MM.YYYY") : "" }}</td>

                    <td width="30px"></td>

                    <td class="text-center" v-for="(td, key) in row.list" :key="`${groupIdx}-${itemIdx}-${key}`">
                      <TaskValue :data="td" />
                    </td>
                    <template v-if="!row.list.length">
                      <td
                        v-for="(_, noopIdx) in [].constructor(tableValuesColumnsLength)"
                        :key="`${groupIdx}-${itemIdx}-${noopIdx}`"
                      ></td>
                    </template>

                    <td width="30px"></td>
                    <td width="90px" class="text-right">
                      <v-btn title="Редактировать" icon small text @click.stop="taskEdit(group, row)">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>

                      <v-btn
                        v-if="!row.finished"
                        title="Остановить задание"
                        icon
                        small
                        text
                        @click.stop="taskToPause(group, row)"
                      >
                        <v-icon>pause_circle_outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </template>
        </v-simple-table>

        <!--
        <div class="rate ">
          <h2 class="mb-3 pt-12 px-2">Динамика параметра</h2>
          <div class="d-flex mt-8">
            <v-icon color="indigo" class="mr-12" size="64">
              mdi-heart-pulse
            </v-icon>
            <v-row align="start">
              <div class="text-caption grey--text text-uppercase">
                Пульс
              </div>
              <div>
                <span class="text-h3 font-weight-black" v-text="120"></span>
                <strong>BPM</strong>
              </div>
            </v-row>
            <v-select v-model="selected" :items="sparksFor" label="Тип" item-text="label" item-value="value"></v-select>
          </div>

          <v-spacer></v-spacer>

          <v-sparkline
            :value="value"
            :gradient="gradient"
            :smooth="radius || false"
            :padding="padding"
            :line-width="width"
            :stroke-linecap="lineCap"
            :gradient-direction="gradientDirection"
            :fill="fill"
            :type="type"
            :auto-line-width="autoLineWidth"
            auto-draw
          ></v-sparkline>
        </div>
        -->

        <!--
        <h2 class="mb-3 pt-12 px-2">История назначения заданий</h2>
        <v-timeline dense class="mt-6">
          <v-timeline-item>Нзначено задание "Измерение давления каждые 4 дня"</v-timeline-item>
          <v-timeline-item>timeline item</v-timeline-item>
          <v-timeline-item>timeline item</v-timeline-item>
        </v-timeline>
        -->

        <div class="pt-12">
          <Calendar hide-patient></Calendar>
        </div>
        <!--
        <v-footer color="primary lighten-1" padless>
          <v-row justify="center" no-gutters>
            <v-btn small text rounded class="my-2">
              <v-icon class="mr-2">mdi-history</v-icon>
              <span>Назначенные задания</span>
            </v-btn>

            <v-btn small text rounded class="my-2">
              <v-icon class="mr-2">mdi-heart</v-icon>
              <span>Динамика параметра</span>
            </v-btn>

            <v-btn small text rounded class="my-2">
              <v-icon class="mr-2">mdi-map-marker</v-icon>
              <span>История назначения заданий</span>
            </v-btn>
            <v-btn small text rounded class="my-2">
              <v-icon class="mr-2">mdi-map-marker</v-icon>
              <span>Календарь</span>
            </v-btn>
          </v-row>
        </v-footer>
        -->
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
import Calendar from "@/views/pages/ikp/components/Calendar";
import DateRangePicker from "@/components/forms/DateRangePicker.vue";
import { groupBy } from "@/services/utils.js";
import EditTaskItem from "@/views/pages/tasks/components/EditTaskItem.vue";
import ShowTaskItem from "@/views/pages/tasks/components/ShowTaskItem.vue";
import { TasksRepository } from "@/modules/tasks/tasks.repository.js";
import AddTaskItem from "@/views/pages/tasks/components/AddTaskItem.vue";
import { TaskDatePeriods, TaskGroups } from "@/modules/tasks/tasks.config.js";
import TaskValue from "@/views/pages/tasks/components/TaskValue.vue";
import debounce from "lodash/debounce";
import TasksReport from "@/views/pages/tasks/components/TasksReport.vue";
import { TaskValueFactory } from "@/modules/tasks/task-value/task-value.factory.js";
import { EntityReminderValue } from "@/modules/tasks/task-value/entities/EntityReminderValue.js";

export default {
  name: "TasksList",
  components: { TasksReport, TaskValue, DateRangePicker, Calendar },

  data() {
    const gradients = [
      ["#222"],
      ["#42b3f4"],
      ["red", "orange", "yellow"],
      ["purple", "violet"],
      ["#00c6ff", "#F0F", "#FF0"],
      ["#f72047", "#ffd200", "#1feaea"],
    ];

    return {
      menuValue: 1,
      tab: 0,
      filter: {
        date: [
          this.$date()
            .subtract(6, "day")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
          // "2021-12-08",
          // "2021-12-10",
        ],
        groupBy: "days",
        taskGroup: "",
      },
      datepickerConfig: {},
      durationList: [],
      periodicityList: [],
      taskGroupList: [],
      groupListBy: [],
      taskTypesList: [], // Список типов заданий
      tableHeader: [],
      loadingList: false,
      listData: {},
      listDataValues: null,

      width: 2,
      radius: 10,
      padding: 8,
      lineCap: "round",
      gradient: gradients[5],
      value: [0, 2, 5, 9, 5, 10, 3, 5, 0, 0, 1, 8, 2, 9, 0],
      gradientDirection: "top",
      gradients,
      fill: false,
      type: "trend",
      autoLineWidth: false,
      sparksFor: [
        { value: "measure", label: "Пульс" },
        { value: "control", label: "Систолическое Давление" },
        { value: "pps", label: "Глюкоза" },
        { value: "io", label: "..." },
      ],
      selected: "measure",
      taskValueFactory: new TaskValueFactory(),
    };
  },

  computed: {
    tableValuesColumnsLength() {
      return this.tableHeader.length;
    },

    tableColumnsLength() {
      return this.tableValuesColumnsLength + 7;
    },

    shouldDisableDatepicker() {
      return this.filter.groupBy !== "days";
    },

    shouldDisableLoadNextPeriod() {
      return this.$date().isSameOrBefore(this.filter.date[1], "day");
    },

    periodicityListByKey() {
      const result = {};
      for (const item of this.periodicityList) {
        result[item.id] = item;
      }

      return result;
    },

    /**
     * Объект содержит список групп заданий пациента
     * @return {{[key: string]: TaskGroup}}
     */
    taskGroupListByKey() {
      const result = {};
      for (const item of this.taskGroupList) {
        result[item.id] = item;
      }

      return result;
    },

    /**
     * В методе сливаются задачи с измерениями за выбранный период
     */
    list() {
      const listData = Object.values(this.listData);

      return listData.map(taskGroup => {
        if (this.listDataValues && this.listDataValues[taskGroup.code]) {
          taskGroup.items = taskGroup.items.map(item => {
            if (item.id && this.listDataValues[taskGroup.code][item.id]) {
              item.list = [];

              for (const tableHeader of this.tableHeader) {
                if (this.listDataValues[taskGroup.code][item.id][tableHeader.data]) {
                  const val = JSON.parse(this.listDataValues[taskGroup.code][item.id][tableHeader.data]);
                  const valItem = this.taskValueFactory.build(taskGroup.code, tableHeader.title, val);
                  if (valItem instanceof EntityReminderValue) {
                    console.log("valueItem", valItem);
                  }
                  item.list.push(valItem);
                }
              }
            }

            return { ...item };
          });
        }

        return taskGroup;
      });
    },
  },

  watch: {
    "filter.taskGroup"(newVal) {
      if (!newVal) {
        this.loadListData();
        return;
      }

      this.loadingList = true;
      this.$http
        .get(`/v1/customers/${this.$store.state.customer.id}/scheduled-events/groups/${newVal}`)
        .then(({ data }) => {
          this.listData = this.prepareListData(data?.data || []);
        })
        .catch(e => {
          console.error(e);
          this.$dialog.notify.error("Ошибка загрузки заданий");
        })
        .finally(() => {
          this.loadingList = false;
        });
    },

    "filter.groupBy"(newVal) {
      if (TaskDatePeriods.days === newVal) {
        this.filter.date = [
          // По факту получится 4 недели
          this.$date()
            .subtract(6, "day")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.week === newVal) {
        this.filter.date = [
          // По факту получится 4 недели
          this.$date()
            .subtract(3, "week")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.month === newVal) {
        this.filter.date = [
          // По факту получится 4 месяца
          this.$date()
            .startOf("month")
            .subtract(3, "month")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.quartets === newVal) {
        this.filter.date = [
          // По факту получится 4 квартала, это равносильно полному году
          this.$date()
            .startOf("quarter")
            .subtract(3, "quarter")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.years === newVal) {
        this.filter.date = [
          // По факту получится 1 год
          this.$date()
            .startOf("year")
            .format("YYYY-MM-DD"),
          this.$date().format("YYYY-MM-DD"),
        ];
      }

      this.loadListDataValues();
    },

    "filter.date"() {
      this.loadListDataValues();
    },
  },

  async created() {
    // Первыми грузим справочники
    await Promise.all([
      this.loadDurationList(),
      this.loadPeriodicityList(),
      this.loadTaskGroupsList(),
      this.loadGroupByPeriodsList(),
      this.loadTaskTypesList(),
    ]);
    // После справочников грузим список основных данных
    await this.loadListData();
    await this.loadListDataValues();

    // Слушает добавление новой группы заданий из темплейта и релоадим список
    this.$bus.$on("addNewTaskGroup", () => {
      this.loadTaskGroupsList();
      this.loadListData();
      this.updateCalendar();
    });
  },

  async destroyed() {
    this.$bus.$off("addNewTaskGroup");
  },

  methods: {
    taskShow(type, item) {
      this.$dialog.show(ShowTaskItem, {
        type,
        item,
        onDelete: () => {
          this.listData[type.code].items = this.listData[type.code].items.filter(listItem => listItem.id !== item.id);
          this.$bus.$emit("TASK_LIST_UPDATE");
        },
        width: 1200,
      });
    },

    // TODO: когда задача на паузе возобновляется тогда нужно перемещать ее на верх списка
    async taskEdit(type, item) {
      const result = await this.$dialog.showAndWait(EditTaskItem, { type, item, width: 1200, persistent: true });
      if (!result) {
        return;
      }

      this.listData[type.code].items = this.listData[type.code].items.map(listItem => {
        if (listItem.id === result.id) {
          return { ...result };
        }

        return listItem;
      });
    },

    async taskToPause(type, item) {
      const result = await this.$dialog.confirm({
        title: "Отмена задания",
        text: `Вы уверенны, что хотите отменить задание?`,
      });

      if (result) {
        const nowDate = this.$date().format("YYYY-MM-DD");
        await TasksRepository.update(this.$store.state.customer.id, item.id, {
          end_at: nowDate,
        });

        this.listData[type.code].items = this.listData[type.code].items.filter(listItem => listItem.id !== item.id);
        this.listData[type.code].items.push({ ...item, endAt: nowDate, finished: true });
      }
    },

    /**
     * Добавляет произвольную задачу
     *
     * @param type
     * @returns {Promise<void>}
     */
    async taskAdd(type) {
      const task = await this.$dialog.showAndWait(AddTaskItem, { type: type, width: 1200, persistent: true });
      if (!task) {
        return;
      }

      this.listData[type.code].items.push(task);
      this.updateCalendar();
      this.$bus.$emit("TASK_LIST_UPDATE");
    },

    async loadDurationList() {
      try {
        this.durationList = await TasksRepository.duration();
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки списка 'длительности периодов'");
      }
    },

    async loadPeriodicityList() {
      try {
        this.periodicityList = await TasksRepository.periodicity();
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки списка 'переодичностей'");
      }
    },

    async loadTaskGroupsList() {
      try {
        const tasks = await TasksRepository.groups(this.$store.state.customer.id);
        this.taskGroupList = [{ id: "", title: "Показать все" }, ...tasks];
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки списка 'групп заданий'");
      }
    },

    async loadGroupByPeriodsList() {
      try {
        this.groupListBy = await TasksRepository.groupsByPeriods();
      } catch (e) {
        this.$dialog.notify.error("Ошибка загрузки списка 'временных периодов'");
      }
    },

    async loadTaskTypesList() {
      try {
        this.taskTypesList = await TasksRepository.taskTypesList();
      } catch (e) {
        this.$dialog.notify.error("Ошибка загрузки списка 'Типов заданий'");
      }
    },

    /**
     * Метод нужно будет вынести в сервис, так как в нем проходит формирования нужного формата данных, форматы зависят от типа,
     * типов будет много у каждого типа свой пейлоад
     *
     * @returns {Promise<void>}
     */
    async loadListData() {
      try {
        this.loadingList = true;
        const { data } = await this.$http.get(`/v1/customers/${this.$store.state.customer.id}/scheduled-events`);

        this.listData = this.prepareListData(data?.data || []);
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки заданий");
      } finally {
        this.loadingList = false;
      }
    },

    /**
     * @param {object[]} data
     * @returns object
     */
    prepareListData(data = []) {
      if (!data.length) {
        // Добавляем группы заданий, для возможности добавить в эту группу задание
        const listData = {};
        this.taskTypesList.forEach(taskType => {
          listData[taskType.id] = {
            name: taskType.name,
            code: taskType.id,
            items: [],
          };
        });

        return listData;
      }

      const listData = {};
      const types = groupBy("entity_type")(data);

      for (const typeKey in types) {
        const listItem = {
          name: this.$i18n.t(`tasks.types.${typeKey}`),
          code: typeKey,
          items: [],
        };
        const itemsOnPause = [];

        types[typeKey].forEach(typeItem => {
          const entityPayload = JSON.parse(typeItem.entity_payload);
          let entity = null;

          // TODO: вынести в общий сервис
          if ([TaskGroups.param, TaskGroups.symptom].includes(typeKey)) {
            entity = {
              id: +typeItem.entity_id,
              name: entityPayload.title,
            };
          }

          // Парсим массив дат из типа периода "На даты"
          const datetimes = typeItem.datetimes ? JSON.parse(typeItem.datetimes) : [];

          /**
           * @type {TaskScheduledEvent} item
           */
          const item = {
            id: typeItem.id,
            authorId: typeItem.author_id,
            group: this.taskGroupListByKey[typeItem.event_schedule_group_id],
            name: entityPayload.title,
            entity: entity,
            entityId: typeItem.entity_id,
            periodicity: this.periodicityListByKey[typeItem.event_periodicity_id],
            startAt: typeItem.start_at ? this.$date(typeItem.start_at).format("YYYY-MM-DD") : "",
            endAt: typeItem.end_at ? this.$date(typeItem.end_at).format("YYYY-MM-DD") : "",
            datetimes: datetimes.map(dt => this.$date(dt).format("YYYY-MM-DD HH:mm")),
            diseases: Array.isArray(entityPayload.diseases) && entityPayload.diseases[0] ? entityPayload.diseases[0] : null,
            critical: entityPayload?.fields?.critical || false,
            limited: entityPayload?.fields?.limited || false,
            lifelong: entityPayload?.fields?.lifelong || false,
            finished: this.$date().isSame(this.$date(typeItem.end_at), "day"),
            order: typeItem.order,
            factor: typeItem.factor,
            comment: typeItem.comment || "",
            list: [],
          };

          if (item.finished) {
            itemsOnPause.push(item);
          } else {
            listItem.items.push(item);
          }
        });

        // Сливаем задания с заданиями которые на паузе
        listItem.items = [...listItem.items, ...itemsOnPause];

        listData[typeKey] = listItem;
      }

      // Добавляем отсутствующие группы заданий
      this.taskTypesList.forEach(taskType => {
        if (listData[taskType.id] === undefined) {
          listData[taskType.id] = {
            name: taskType.name,
            code: taskType.id,
            items: [],
          };
        }
      });

      return listData;
    },

    /**
     * Загружает измерения по заданиям
     * TODO: такой debounce делать плохо
     *
     * @returns {Promise<void>}
     */
    loadListDataValues: debounce(async function() {
      try {
        this.loadingList = true;
        const { data } = await this.$http.get(`/v1/customers/${this.$store.state.customer.id}/event-analysis/observed`, {
          params: {
            groupBy: this.filter.groupBy,
            start: this.filter.date[0],
            end: this.filter.date[1],
            groups: this.filter.taskGroup ? [this.filter.taskGroup] : null,
            events: null,
          },
        });

        // Формируем корректные колонки значений
        this.tableHeader = (data?.columns || []).map(column => {
          if (TaskDatePeriods.days === this.filter.groupBy) {
            column.title = this.$date(column.title).format("DD.MM.YYYY");
          } else if (TaskDatePeriods.week === this.filter.groupBy) {
            column.title = this.$date(column.title).format("DD.MM.YYYY");
          } else if (TaskDatePeriods.month === this.filter.groupBy) {
            column.title = this.$date(column.title).format("MMM YYYY");
          } else if (TaskDatePeriods.quartets === this.filter.groupBy) {
            const initialDate = this.$date(column.title);
            column.title = `${initialDate.format("MMM")} - ${initialDate.add(2, "month").format("MMM")}`;
          } else if (TaskDatePeriods.years === this.filter.groupBy) {
            column.title = this.$date(column.title).format("YYYY");
          }

          return column;
        });
        /**
         * Собираем объект вида {taskGroup: {id: value}, taskGroup2: {id: value}}
         */
        const values = {};

        for (const item of data?.data || []) {
          if (!values[item.entity_type]) {
            values[item.entity_type] = {};
          }

          values[item.entity_type][item.id] = item;
        }

        this.listDataValues = values;
      } catch (e) {
        console.error(e);
        this.$dialog.notify.error("Ошибка загрузки заданий");
      } finally {
        this.loadingList = false;
      }
    }),

    async loadPrevDatePeriod() {
      if (TaskDatePeriods.days === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .subtract(7, "day")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .subtract(7, "day")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.week === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .subtract(4, "week")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .subtract(4, "week")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.month === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .subtract(4, "month")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .subtract(4, "month")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.quartets === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .subtract(4, "quarter")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .endOf("quarter")
            .subtract(4, "quarter")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.years === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .subtract(1, "year")
            .startOf("year")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .subtract(1, "year")
            .endOf("year")
            .format("YYYY-MM-DD"),
        ];
      }
    },

    async loadNextDatePeriod() {
      if (this.shouldDisableLoadNextPeriod) {
        return;
      }

      if (TaskDatePeriods.days === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .add(7, "day")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .add(7, "day")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.week === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .add(4, "week")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .add(4, "week")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.month === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .add(4, "month")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .add(4, "month")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.quartets === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .add(4, "quarter")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .endOf("quarter")
            .add(4, "quarter")
            .format("YYYY-MM-DD"),
        ];
      } else if (TaskDatePeriods.years === this.filter.groupBy) {
        this.filter.date = [
          this.$date(this.filter.date[0])
            .add(1, "year")
            .startOf("year")
            .format("YYYY-MM-DD"),
          this.$date(this.filter.date[1])
            .add(1, "year")
            .endOf("year")
            .format("YYYY-MM-DD"),
        ];
      }
    },

    updateCalendar() {
      Promise.all([this.$store.dispatch("ikp/loadEvents"), this.$store.dispatch("ikp/loadAgendaEvents")]);
    },
  },
};
</script>

<style lang="scss" scoped>
.tasks-filter {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.tasks-filter .v-input__control,
.tasks-filter .v-text-field {
  margin-top: 0;
  padding-top: 0;
  max-width: 250px;
}

.task-close {
  background-color: lightgray;
}
</style>
